export default {
  props: {
    height: {
      type: [String, Number],
      default: 50
    },
    width: {
      type: [String, Number],
      default: 50
    },
    iconName: {
      type: String,
      default: 'box'
    },
    iconColor: {
      type: String,
      default: null
    }
  }
};
